import React from "react";
// also exported from '@storybook/react' if you can deal with breaking changes in 6.1
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { DateRangeFormControl } from "../Web/DateRangeFormControl";
import { XColumnContainer, XColumnContainerColumn } from "../../Containers";
import { LabelFormControl } from "../Web/LabelFormControl";
import { TextControlSize, TextControlStyle } from "../../Utilities/FormDesignConstants";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration } {
    let ui = new FormConfiguration();
    let container = new XColumnContainer();
    let col1 = new XColumnContainerColumn();
    let col2 = new XColumnContainerColumn();
    col2.interControlSpacing = 20;

    container.add(col1);
    container.add(col2);
    ui.add(container);

    let label = new LabelFormControl();
    label.text = "Large Size";
    col1.add(label);

    let datePicker = new DateRangeFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.valueName = "value";
    datePicker.requiredOnAllOutcomes = false;
    col1.add(datePicker);

    datePicker = new DateRangeFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.style = TextControlStyle.OUTLINE;
    datePicker.valueName = "value";
    datePicker.requiredOnAllOutcomes = false;
    datePicker.overrideStyle = true;
    col1.add(datePicker);

    datePicker = new DateRangeFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.style = TextControlStyle.SHADED;
    datePicker.valueName = "value";
    datePicker.requiredOnAllOutcomes = false;
    datePicker.overrideStyle = true;
    col1.add(datePicker);

    datePicker = new DateRangeFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.valueName = "value";
    datePicker.style = TextControlStyle.UNDERLINED;
    datePicker.requiredOnAllOutcomes = false;
    datePicker.overrideStyle = true;
    col1.add(datePicker);

    label = new LabelFormControl();
    label.text = "Small Size";
    col2.add(label);

    datePicker = new DateRangeFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.valueName = "value";
    datePicker.requiredOnAllOutcomes = false;
    datePicker.size = TextControlSize.SMALL;
    col2.add(datePicker);

    datePicker = new DateRangeFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.style = TextControlStyle.OUTLINE;
    datePicker.valueName = "value";
    datePicker.size = TextControlSize.SMALL;
    datePicker.requiredOnAllOutcomes = false;
    datePicker.overrideStyle = true;
    col2.add(datePicker);

    datePicker = new DateRangeFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.style = TextControlStyle.SHADED;
    datePicker.valueName = "value";
    datePicker.size = TextControlSize.SMALL;
    datePicker.requiredOnAllOutcomes = false;
    datePicker.overrideStyle = true;
    col2.add(datePicker);

    datePicker = new DateRangeFormControl();
    datePicker.label = "DatePicker Label";
    datePicker.style = TextControlStyle.UNDERLINED;
    datePicker.valueName = "value";
    datePicker.size = TextControlSize.SMALL;
    datePicker.requiredOnAllOutcomes = false;
    datePicker.overrideStyle = true;
    col2.add(datePicker);

    return { form: ui };
}

export const DateRangeStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Date Range",
        "Default"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as DateRangeFormControl;
                if (ctf) {
                    ctf.hintText = "hint text";
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Date Range",
        "With Hint"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as DateRangeFormControl;
                if (ctf) {
                    ctf.placeholderText = "placeholder text";
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Date Range",
        "With Placeholder"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as DateRangeFormControl;
                if (ctf) {
                    ctf.requiredOnAllOutcomes = true;
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Date Range",
        "With Validation"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as DateRangeFormControl;
                if (ctf) {
                    ctf.type = "past";
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Date Range",
        "Past"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as DateRangeFormControl;
                if (ctf) {
                    ctf.type = "future";
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Date Range",
        "Future"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as DateRangeFormControl;
                if (ctf) {
                    ctf.type = "both";
                }
            }
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Date Range",
        "Any"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as DateRangeFormControl;
                if (ctf) {
                    ctf.showRange = false;
                }
            }

            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Date Range",
        "Hide Range"
    ),
];
